import { formatNumberWithDecimals } from '@/creditflowresearch/ui/components/deals/helpers';

interface IMoneyCellProps {
  value: number | null | undefined,
  decimals?: number,
}

const MoneyCell = ({ value, decimals = 3 }: IMoneyCellProps) => {
  if (value === null || value === undefined) {
    return (<>-</>);
  }

  return (<>{ formatNumberWithDecimals(value, decimals) }</>);
};

export default MoneyCell;
